/* Paris Mall — comportements de la boutique : ajout au panier, favoris, quantité, visuels. */
(function () {
  'use strict';

  var routes = (window.PM && window.PM.routes) || {};
  var CART_ADD = (routes.cart_add_url || '/cart/add') + '.js';

  // ---- petit message passager ------------------------------------------------
  var timer;
  function message(texte) {
    var el = document.querySelector('.pm-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'pm-toast';
      el.setAttribute('role', 'status');
      document.body.appendChild(el);
    }
    el.textContent = texte;
    el.classList.add('is-on');
    clearTimeout(timer);
    timer = setTimeout(function () { el.classList.remove('is-on'); }, 2400);
  }

  function majCompteur(n) {
    document.querySelectorAll('.pm-js-cart-count').forEach(function (el) {
      el.textContent = n;
      if (n > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
    });
  }

  // ---- livraison offerte : texte et barre suivent le panier ------------------------
  function argent(centimes) {
    var fmt = (window.PM && window.PM.moneyFormat) || '{{amount}} €';
    var euros = centimes / 100;
    var entier = Math.round(centimes) % 100 === 0;
    var nombre = entier ? String(Math.round(euros)) : euros.toFixed(2);
    nombre = nombre.replace('.', ',');
    return fmt.replace(/{{s*[a-z_]+s*}}/, nombre).replace(/<[^>]+>/g, '');
  }
  // Deux seuils : Wash et Misk (franco), Sakan (franco_sakan), chacun sur les articles de son univers.
  // Groupe « tout » (seuil unique) : tout le panier compte.
  function majLivraison() {
    fetch((routes.cart_url || '/cart') + '?view=franco', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.text(); })
      .then(function (t) { appliquerLivraison(JSON.parse(t)); })
      .catch(function () { /* la jauge sera juste au prochain chargement */ });
  }
  function appliquerLivraison(montants) {
    document.querySelectorAll('.pm-js-freeship').forEach(function (el) {
      var seuils = (el.dataset.seuils || '').split(',').map(Number);
      var g = el.dataset.groupe || 'autres';
      if (g === 'auto') g = (!montants.autres && montants.sakan) ? 'sakan' : 'autres';
      var seuil = g === 'sakan' ? seuils[1] : seuils[0];
      if (!seuil) return;
      var total = g === 'tout' ? (montants.sakan || 0) + (montants.autres || 0) : (montants[g] || 0);
      var sur = el.dataset.libelle && g !== 'tout' ? (g === 'sakan' ? ' sur Sakan' : ' sur Wash et Misk') : '';
      var reste = seuil - total;
      var pct = Math.max(0, Math.min(100, Math.round(total * 100 / seuil)));
      el.classList.toggle('is-done', reste <= 0);
      var texte = el.querySelector('.pm-js-freeship-text');
      var barre = el.querySelector('.pm-js-freeship-bar');
      var jauge = el.querySelector('[role="progressbar"]');
      var icone = el.querySelector('.pm-js-freeship-icon');
      var but = el.querySelector('.pm-js-freeship-goal');
      if (but) but.textContent = argent(seuil);
      if (texte) {
        texte.innerHTML = reste <= 0
          ? '<strong>Livraison offerte</strong>' + (sur || ' sur votre commande')
          : total > 0
            ? 'Plus que <strong>' + argent(reste) + '</strong> pour la livraison offerte' + sur
            : '<strong>Livraison offerte</strong> dès ' + argent(seuil) + ' d’achat' + sur;
      }
      if (barre) barre.style.width = pct + '%';
      var rail = el.querySelector('.pm-freeship__rail');
      if (rail) rail.style.setProperty('--p', pct + '%');
      if (jauge) jauge.setAttribute('aria-valuenow', String(pct));
      if (icone && icone.firstElementChild && reste <= 0 && !el.dataset.fait) {
        el.dataset.fait = '1';
        el.classList.add('is-celebrate');
        setTimeout(function () { el.classList.remove('is-celebrate'); }, 1400);
      }
    });
  }

  // ---- ajout au panier sans recharger la page -------------------------------
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.pm-js-add-form, .pm-js-product-form');
    if (!form) return;
    e.preventDefault();
    var bouton = form.querySelector('button[type="submit"]');
    var ajoute = form.querySelector('.pm-add');
    fetch(CART_ADD, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded', Accept: 'application/json' },
      body: new URLSearchParams(new FormData(form)).toString()
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) { message(res.d.description || "Ce produit n'a pas pu être ajouté."); return; }
        if (ajoute) {
          ajoute.classList.add('is-added');
          var dit = form.parentElement.querySelector('[aria-live]');
          if (dit) dit.textContent = 'Ajouté au panier';
          setTimeout(function () { ajoute.classList.remove('is-added'); if (dit) dit.textContent = ''; }, 1600);
        } else if (bouton) {
          message('Ajouté au panier');
        }
        return fetch((routes.cart_url || '/cart') + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (panier) { majCompteur(panier.item_count); majLivraison(panier); });
      })
      .catch(function () { message('Connexion interrompue : réessayez.'); });
  });

  // ---- quantité sur la fiche produit ----------------------------------------
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.pm-js-qty');
    if (!btn) return;
    var form = btn.closest('form');
    var sortie = form.querySelector('.pm-js-qty-value');
    var champ = form.querySelector('.pm-js-qty-input');
    var n = Math.max(1, parseInt(sortie.textContent, 10) + parseInt(btn.dataset.step, 10));
    sortie.textContent = n;
    if (champ) champ.value = n;
    form.querySelector('.pm-js-qty[data-step="-1"]').disabled = n <= 1;
  });

  // ---- visuels de la fiche ---------------------------------------------------
  document.addEventListener('click', function (e) {
    var vignette = e.target.closest('.pm-js-thumb');
    if (!vignette) return;
    var grand = document.querySelector('.pm-pd__img');
    if (grand) {
      // les tailles (srcset) suivent la nouvelle image, sinon le navigateur garderait l'ancienne
      var base = vignette.dataset.src.replace(/([?&])width=\d+/, '$1width=');
      if (grand.hasAttribute('srcset') && /width=$/.test(base)) {
        grand.srcset = [700, 1000, 1400, 2000].map(function (w) { return base + w + ' ' + w + 'w'; }).join(', ');
      } else {
        grand.removeAttribute('srcset');
      }
      grand.src = vignette.dataset.src;
    }
    document.querySelectorAll('.pm-js-thumb').forEach(function (v) { v.classList.toggle('is-active', v === vignette); });
  });

  // ---- fluidité : la page visée est préchargée dès qu'on survole un lien -------------
  (function () {
    var vus = {};
    var eco = navigator.connection && (navigator.connection.saveData || /2g/.test(navigator.connection.effectiveType || ''));
    if (eco) return;
    document.addEventListener('pointerover', function (e) {
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a || vus[a.href] || a.origin !== location.origin || a.hash && a.pathname === location.pathname) return;
      if (/^\/(cart|account|checkout|search|password)/.test(a.pathname)) return;
      vus[a.href] = 1;
      var l = document.createElement('link');
      l.rel = 'prefetch'; l.href = a.href;
      document.head.appendChild(l);
    }, { passive: true });
  })();

  // ---- galerie de la fiche : flèches, balayage au doigt, flèches du clavier ----------
  function galerie(dir) {
    var vignettes = Array.prototype.slice.call(document.querySelectorAll('.pm-js-thumb'));
    if (vignettes.length < 2) return;
    var i = vignettes.findIndex(function (v) { return v.classList.contains('is-active'); });
    var n = (i + dir + vignettes.length) % vignettes.length;
    vignettes[n].click();
    var liste = vignettes[n].closest('.pm-js-thumbs');
    if (liste && vignettes[n].offsetLeft !== undefined) liste.scrollTo({ left: vignettes[n].offsetLeft - 24, behavior: 'smooth' });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.pm-js-gal');
    if (b) galerie(parseInt(b.dataset.dir, 10));
  });
  (function () {
    var x0 = null, y0 = null;
    document.addEventListener('touchstart', function (e) {
      var s = e.target.closest && e.target.closest('.pm-js-stage');
      if (!s) { x0 = null; return; }
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
    }, { passive: true });
    document.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      x0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) galerie(dx < 0 ? 1 : -1);
    }, { passive: true });
    document.addEventListener('keydown', function (e) {
      if (!document.querySelector('.pm-js-stage')) return;
      var t = e.target.tagName;
      if (t === 'INPUT' || t === 'TEXTAREA' || t === 'SELECT') return;
      if (e.key === 'ArrowRight') galerie(1);
      if (e.key === 'ArrowLeft') galerie(-1);
    });
  })();

  // ---- favoris : gardés dans ce navigateur -----------------------------------
  var CLE = 'pm.favoris';
  function favoris() {
    try { return JSON.parse(localStorage.getItem(CLE)) || []; } catch (err) { return []; }
  }
  function ecrire(liste) {
    try { localStorage.setItem(CLE, JSON.stringify(liste)); } catch (err) { /* navigation privée */ }
    document.querySelectorAll('.pm-js-fav-count').forEach(function (el) {
      el.textContent = liste.length;
      if (liste.length > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
    });
  }
  function peindre() {
    var liste = favoris();
    document.querySelectorAll('.pm-js-fav').forEach(function (b) {
      var actif = liste.indexOf(b.dataset.handle) >= 0;
      b.setAttribute('aria-pressed', actif ? 'true' : 'false');
      b.classList.toggle('is-on', actif);
    });
    ecrire(liste);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.pm-js-fav');
    if (!b) return;
    var liste = favoris();
    var i = liste.indexOf(b.dataset.handle);
    if (i >= 0) liste.splice(i, 1); else liste.push(b.dataset.handle);
    ecrire(liste);
    b.setAttribute('aria-pressed', i >= 0 ? 'false' : 'true');
    b.classList.toggle('is-on', i < 0);
    b.classList.remove('is-pop');
    void b.offsetWidth;
    if (i < 0) b.classList.add('is-pop');
    // page Favoris : un produit retiré quitte la grille
    var grille = b.closest('.pm-js-favoris');
    if (grille && i >= 0) {
      var carte = b.closest('.pm-product');
      if (carte) carte.remove();
      if (!grille.children.length) { var v = document.querySelector('.pm-js-favoris-vide'); if (v) v.hidden = false; }
    }
  });

  // ---- page Favoris : charge la carte de chaque produit gardé -------------------
  (function () {
    var grille = document.querySelector('.pm-js-favoris');
    if (!grille) return;
    var vide = document.querySelector('.pm-js-favoris-vide');
    var liste = favoris();
    if (!liste.length) { if (vide) vide.hidden = false; return; }
    Promise.all(liste.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '?view=carte')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    })).then(function (cartes) {
      var html = cartes.filter(function (c) { return c.indexOf('pm-product') >= 0; }).join('');
      grille.innerHTML = html;
      if (!html && vide) vide.hidden = false;
      peindre();
    });
  })();

  // ---- variantes : suivre le choix des options (prix, disponibilité, visuel, abonnement) --------
  function chargerProduit() {
    if (window.PM && window.PM.produit) return window.PM.produit;
    var el = document.querySelector('.pm-js-produit');
    if (!el) return null;
    try { window.PM = window.PM || {}; window.PM.produit = JSON.parse(el.textContent); } catch (err) { return null; }
    return window.PM.produit;
  }
  function montantCts(c) { return typeof argent === 'function' ? argent(c) : String(c / 100); }
  // chemin du fichier seul : le domaine varie (myshopify, domaine de la boutique, aperçu local)
  function racine(u) { return String(u || '').split('?')[0].replace(/^(https?:)?\/\/[^/]+/, ''); }
  function appliquerVariante(v, form) {
    // prix principal et barre d'achat
    document.querySelectorAll('.pm-pd__price .pm-price, .pm-buybar .pm-price').forEach(function (p) {
      var now = p.querySelector('.pm-price__now');
      var was = p.querySelector('.pm-price__was');
      var promo = v.compare_at_price && v.compare_at_price > v.price;
      if (now) {
        now.innerHTML = '<span class="pm-sr">Prix : </span>' + montantCts(v.price);
        now.classList.toggle('is-promo', !!promo);
      }
      if (promo) {
        if (!was) { was = document.createElement('s'); was.className = 'pm-price__was'; p.appendChild(was); }
        was.innerHTML = '<span class="pm-sr">au lieu de </span>' + montantCts(v.compare_at_price);
      } else if (was) { was.remove(); }
    });
    // lot : « Lot de N · soit X l'unité » suit la variante choisie (prix d'un lot, pas d'un seul article)
    var lotN = 0;
    (v.options || []).forEach(function (o) { var m = /^Lot de (\d+)/.exec(o); if (m) lotN = Number(m[1]); });
    var lotLong = document.querySelector('.pm-js-lot'), lotCourt = document.querySelector('.pm-js-lot-court');
    if (lotLong && lotLong.hasAttribute('data-titre')) { lotLong = null; lotCourt = null; } // lot annoncé par le titre du produit : rien à recalculer
    if (lotLong) {
      lotLong.hidden = !lotN;
      if (lotN) lotLong.innerHTML = '<strong>Lot de ' + lotN + '</strong> &middot; soit ' + montantCts(Math.round(v.price / lotN)) + " l'unité";
    }
    if (lotCourt) { lotCourt.hidden = !lotN; lotCourt.textContent = lotN ? 'Lot de ' + lotN : ''; }
    // pack en plusieurs finitions : la liste et la grille des articles suivent la finition choisie
    if (document.querySelector('.pm-js-packlist[data-par-variante]')) {
      fetch(location.pathname + '?variant=' + v.id, { headers: { Accept: 'text/html' } })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          ['.pm-js-packlist', '#pack-contenu'].forEach(function (sel) {
            var ici = document.querySelector(sel), neuf = doc.querySelector(sel);
            if (ici && neuf) ici.innerHTML = neuf.innerHTML;
          });
        })
        .catch(function () { /* la liste se mettra à jour au prochain chargement */ });
    }
    // économie affichée
    var eco = document.querySelector('.pm-pd__save');
    if (eco) {
      var promoV = v.compare_at_price && v.compare_at_price > v.price;
      eco.hidden = !promoV;
      if (promoV) {
        var pctV = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price);
        var pEl = eco.querySelector('.pm-js-save-pct'), mEl = eco.querySelector('.pm-js-save-amount');
        if (pEl) pEl.textContent = '(−' + pctV + ' %)';
        if (mEl) mEl.textContent = montantCts(v.compare_at_price - v.price);
      }
    }
    // disponibilité
    document.querySelectorAll('.pm-pd__cta .pm-btn, .pm-buybar .pm-btn').forEach(function (btn) {
      btn.disabled = !v.available;
      var lab = btn.querySelector('.pm-btn__label');
      if (lab) {
        if (!btn.dataset.libelle) btn.dataset.libelle = lab.textContent;
        lab.textContent = v.available ? btn.dataset.libelle : 'Épuisé';
      }
    });
    // visuel de la variante
    var img = v.featured_image && (v.featured_image.src || v.featured_image);
    if (img) {
      var cible = racine(img);
      var vignette = Array.prototype.slice.call(document.querySelectorAll('.pm-js-thumb')).filter(function (t) { return racine(t.dataset.src) === cible; })[0];
      if (vignette && !vignette.classList.contains('is-active')) vignette.click();
    }
    // abonnement : prix de chaque fréquence pour cette variante
    form.querySelectorAll('.pm-js-subopt').forEach(function (bloc) {
      var once = bloc.querySelector('.pm-js-opt-once .pm-subopt__now');
      if (once) once.textContent = montantCts(v.price);
      var sel = bloc.querySelector('.pm-js-plan-select');
      var allocs = v.selling_plan_allocations || [];
      if (sel && allocs.length) {
        Array.prototype.forEach.call(sel.options, function (o) {
          var al = allocs.filter(function (x) { return String(x.selling_plan_id) === String(o.value); })[0];
          if (al) o.dataset.price = montantCts(al.price);
        });
        var was = bloc.querySelector('.pm-js-opt-sub .pm-subopt__was');
        if (was) was.innerHTML = '<span class="pm-sr">au lieu de </span>' + montantCts(v.price);
        majAbonnement(bloc);
      }
    });
  }
  document.addEventListener('change', function (e) {
    if (!e.target.classList.contains('pm-js-option')) return;
    var form = e.target.closest('form');
    var produit = chargerProduit();
    if (!produit) return;
    var choisies = Array.prototype.map.call(form.querySelectorAll('.pm-js-option:checked'), function (i) { return i.value; });
    var idxModif = Number(String(e.target.name).replace('option', '')) - 1;
    // combinaison exacte, sinon la variante qui garde le plus de choix (celui qu'on vient de changer en priorité)
    var meilleure = null, score = -1;
    produit.variants.forEach(function (v) {
      var s = 0;
      choisies.forEach(function (val, idx) { if (v.options[idx] === val) s += (idx === idxModif ? 1.5 : 1); });
      if (s > score) { score = s; meilleure = v; }
    });
    if (!meilleure) return;
    // aligner les boutons si la combinaison demandée n'existe pas
    meilleure.options.forEach(function (val, idx) {
      var radio = form.querySelector('input.pm-js-option[name="option' + (idx + 1) + '"][value="' + String(val).replace(/"/g, '\\"') + '"]');
      if (radio && !radio.checked) radio.checked = true;
    });
    form.querySelector('.pm-js-variant').value = meilleure.id;
    var url = new URL(window.location);
    url.searchParams.set('variant', meilleure.id);
    window.history.replaceState({}, '', url);
    appliquerVariante(meilleure, form);
  });

  // ---- filtres du rayon : renvoyer le formulaire dès qu'un choix change -------
  document.addEventListener('change', function (e) {
    var champ = e.target.closest('.pm-js-filters input, .pm-js-autosubmit');
    if (!champ) return;
    var form = champ.closest('form');
    if (form.closest('.pm-filters--sheet')) return; // la feuille mobile attend « Afficher »
    form.submit();
  });

  // ---- filtres sur mobile : feuille en bas d'écran ---------------------------
  document.addEventListener('click', function (e) {
    var ouvrir = e.target.closest('.pm-js-filters-open');
    var fermer = e.target.closest('.pm-js-filters-close');
    var dialogue = document.querySelector('.pm-js-filters-dialog');
    if (!dialogue) return;
    // iOS avant 15.4 : pas de showModal, la feuille s'ouvre simplement (attribut open)
    if (ouvrir) { if (dialogue.showModal) dialogue.showModal(); else dialogue.setAttribute('open', ''); }
    if (fermer || e.target === dialogue) { if (dialogue.close) dialogue.close(); else dialogue.removeAttribute('open'); }
  });

  // ---- onglets : l'indicateur suit l'onglet actif ------------------------------
  function placerOnglets() {
    document.querySelectorAll('.pm-tabs').forEach(function (barre) {
      var ind = barre.querySelector('.pm-tabs__ind');
      var actif = barre.querySelector('.pm-tab-btn.is-active');
      if (!ind || !actif) return;
      ind.style.transform = 'translateX(' + actif.offsetLeft + 'px)';
      ind.style.width = actif.offsetWidth + 'px';
      if (actif.scrollIntoView) barre.scrollLeft = Math.max(0, actif.offsetLeft - 24);
    });
  }
  window.addEventListener('resize', placerOnglets);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(placerOnglets);

  // ---- avis : carrousel, flèches et barre de progression ---------------------------
  function majAvis(bloc) {
    var piste = bloc.querySelector('.pm-js-reviews-track');
    if (!piste) return;
    var max = piste.scrollWidth - piste.clientWidth;
    var debut = piste.scrollLeft < 4;
    var fin = max <= 4 || piste.scrollLeft > max - 4;
    var r = piste.scrollWidth ? Math.min(1, piste.clientWidth / piste.scrollWidth) : 1;
    var p = max > 4 ? piste.scrollLeft / max : 0;
    var barre = bloc.querySelector('.pm-js-reviews-bar');
    if (barre) { barre.style.width = (r * 100) + '%'; barre.style.left = (p * (1 - r) * 100) + '%'; }
    var prec = bloc.querySelector('.pm-js-reviews-prev');
    var suiv = bloc.querySelector('.pm-js-reviews-next');
    if (prec) prec.disabled = debut;
    if (suiv) suiv.disabled = fin;
    piste.classList.toggle('is-end', fin);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.pm-js-reviews-prev, .pm-js-reviews-next');
    if (!b) return;
    var bloc = b.closest('.pm-js-reviews');
    var piste = bloc.querySelector('.pm-js-reviews-track');
    var carte = piste.firstElementChild;
    var ecart = parseFloat(getComputedStyle(piste).columnGap) || 16;
    var pas = carte ? carte.getBoundingClientRect().width + ecart : piste.clientWidth * 0.8;
    var calme = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    piste.scrollBy({ left: b.classList.contains('pm-js-reviews-prev') ? -pas : pas, behavior: calme ? 'auto' : 'smooth' });
  });
  function initAvis() {
    document.querySelectorAll('.pm-js-reviews').forEach(function (bloc) {
      var piste = bloc.querySelector('.pm-js-reviews-track');
      if (!piste) return;
      piste.addEventListener('scroll', function () { majAvis(bloc); }, { passive: true });
      majAvis(bloc);
    });
  }
  window.addEventListener('resize', function () { document.querySelectorAll('.pm-js-reviews').forEach(majAvis); });
  // ---- cartes d'univers : inclinaison et profondeur au passage de la souris -------------
  (function () {
    var fin = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var calme = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!fin || calme) return;
    document.addEventListener('mousemove', function (e) {
      var carte = e.target.closest && e.target.closest('.pm-ucard');
      if (!carte) return;
      var r = carte.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - 0.5;
      var y = (e.clientY - r.top) / r.height - 0.5;
      carte.style.setProperty('--ry', (x * 7).toFixed(2) + 'deg');
      carte.style.setProperty('--rx', (-y * 5).toFixed(2) + 'deg');
      carte.style.setProperty('--mx', (x * 16).toFixed(1) + 'px');
      carte.style.setProperty('--my', (y * 12).toFixed(1) + 'px');
    }, { passive: true });
    document.addEventListener('mouseout', function (e) {
      var carte = e.target.closest && e.target.closest('.pm-ucard');
      if (!carte || (e.relatedTarget && carte.contains(e.relatedTarget))) return;
      ['--rx', '--ry'].forEach(function (p) { carte.style.setProperty(p, '0deg'); });
      ['--mx', '--my'].forEach(function (p) { carte.style.setProperty(p, '0px'); });
    }, { passive: true });
  })();

  // ---- offres du moment : onglets par univers ------------------------------------
  document.addEventListener('click', function (e) {
    var onglet = e.target.closest('.pm-js-offers-tabs .pm-tab-btn');
    if (!onglet) return;
    var barre = onglet.closest('.pm-js-offers-tabs');
    barre.querySelectorAll('.pm-tab-btn').forEach(function (b) {
      var actif = b === onglet;
      b.classList.toggle('is-active', actif);
      b.setAttribute('aria-pressed', actif ? 'true' : 'false');
    });
    var grille = barre.closest('section').querySelector('[data-offers]');
    var max = grille.hasAttribute('data-carrousel') ? Infinity : (parseInt(grille.dataset.max, 10) || 4);
    var voulu = onglet.dataset.u;
    var n = 0;
    grille.querySelectorAll('.pm-offer').forEach(function (c) {
      var ok = (voulu === 'tout' || c.dataset.u === voulu) && n < max;
      if (ok) n++;
      c.hidden = !ok;
    });
    if (grille.hasAttribute('data-carrousel')) grille.scrollTo({ left: 0, behavior: 'auto' });
    placerOnglets();
  });

  // ---- offres du moment : carrousel qui défile tout seul (pause au survol, au toucher, au clavier) ----
  function initCarrousels() {
    var calmeCar = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('[data-carrousel]').forEach(function (piste) {
      var boite = piste.closest('.pm-offers-car') || piste.parentElement;
      var pause = false, reprise;
      function pas() {
        var carte = piste.querySelector('.pm-offer:not([hidden])');
        var gap = parseFloat(getComputedStyle(piste).columnGap || getComputedStyle(piste).gap) || 16;
        return carte ? carte.getBoundingClientRect().width + gap : piste.clientWidth * 0.8;
      }
      function aller(dir) {
        var fin = piste.scrollWidth - piste.clientWidth - 4;
        if (dir > 0 && piste.scrollLeft >= fin) piste.scrollTo({ left: 0, behavior: 'smooth' });
        else if (dir < 0 && piste.scrollLeft <= 4) piste.scrollTo({ left: fin, behavior: 'smooth' });
        else piste.scrollBy({ left: dir * pas(), behavior: 'smooth' });
      }
      function arreter() { pause = true; clearTimeout(reprise); }
      function relancer(delai) { clearTimeout(reprise); reprise = setTimeout(function () { pause = false; }, delai || 2500); }
      boite.querySelectorAll('.pm-js-car-nav').forEach(function (b) {
        b.addEventListener('click', function () { arreter(); aller(+b.dataset.dir); relancer(6000); });
      });
      boite.addEventListener('pointerenter', arreter);
      boite.addEventListener('pointerleave', function () { relancer(1200); });
      piste.addEventListener('touchstart', function () { arreter(); relancer(6000); }, { passive: true });
      piste.addEventListener('focusin', arreter);
      piste.addEventListener('focusout', function () { relancer(2500); });
      if (calmeCar) return;
      setInterval(function () {
        if (pause || document.hidden) return;
        var r = piste.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return; // hors écran : on ne bouge pas
        aller(1);
      }, 3200);
    });
  }
  // ---- menu déroulant (mobile) ---------------------------------------------------
  function menu(ouvrir, focus) {
    var panneau = document.getElementById('pm-menu');
    var voile = document.querySelector('.pm-menu__scrim');
    if (!panneau) return;
    panneau.hidden = !ouvrir;
    if (voile) voile.hidden = !ouvrir;
    document.documentElement.classList.toggle('pm-menu-open', ouvrir);
    document.querySelectorAll('.pm-js-menu-open').forEach(function (b) { b.setAttribute('aria-expanded', ouvrir ? 'true' : 'false'); });
    if (ouvrir) {
      requestAnimationFrame(function () { panneau.classList.add('is-on'); });
      if (focus === 'search') { var q = document.getElementById('pm-menu-q'); if (q) setTimeout(function () { q.focus(); }, 120); }
    } else {
      panneau.classList.remove('is-on');
    }
  }
  document.addEventListener('click', function (e) {
    var ouvre = e.target.closest('.pm-js-menu-open');
    if (ouvre) {
      var panneau = document.getElementById('pm-menu');
      var dejaOuvert = panneau && !panneau.hidden;
      menu(!dejaOuvert, ouvre.dataset.focus);
      return;
    }
    if (e.target.closest('.pm-js-menu-close') || e.target.closest('.pm-menu__link')) menu(false);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') menu(false); });
  window.addEventListener('resize', function () { if (window.innerWidth >= 768) menu(false); });

  // ---- abonnement : fréquences triées de la plus courte à la plus longue ---------------
  function jours(nom) {
    var t = (nom || '').toLowerCase();
    var n = (t.match(/(\d+)\s*(semaine|mois|an)/) || []);
    var k = n[1] ? parseInt(n[1], 10) : 1;
    if (/semaine/.test(t)) return k * 7;
    if (/mois/.test(t)) return k * 30;
    if (/an/.test(t)) return k * 365;
    return 9999;
  }
  function trierFrequences() {
    document.querySelectorAll('.pm-js-plan-select').forEach(function (sel) {
      var opts = Array.prototype.slice.call(sel.options);
      // libellés courts : « Chaque mois · −4 % »
      opts.forEach(function (o) {
        var t = o.textContent.trim().replace(/^Livrer\s+/i, '');
        t = t.replace(/,\s*R[ée]duction de\s*(\d+)\s*%/i, ' · −$1 %');
        o.textContent = t.charAt(0).toUpperCase() + t.slice(1);
      });
      opts.sort(function (a, b) { return jours(a.textContent) - jours(b.textContent); });
      opts.forEach(function (o) { sel.appendChild(o); });
      var mensuel = opts.filter(function (o) { return jours(o.textContent) === 30; })[0];
      sel.value = (mensuel || opts[0]).value;
      var bloc = sel.closest('.pm-js-subopt');
      if (bloc) majAbonnement(bloc);
    });
  }

  // ---- abonnement : achat unique ou abonnement, avec le choix de la fréquence ------------
  function majAbonnement(bloc) {
    var radio = bloc.querySelector('.pm-js-submode:checked');
    var abo = radio && radio.value === 'sub';
    var sel = bloc.querySelector('.pm-js-plan-select');
    var champ = bloc.querySelector('.pm-js-plan');
    bloc.querySelector('.pm-js-opt-once').classList.toggle('is-checked', !abo);
    bloc.querySelector('.pm-js-opt-sub').classList.toggle('is-checked', abo);
    bloc.querySelector('.pm-js-sub-wrap').classList.toggle('is-open', abo);
    var panneau = bloc.querySelector('.pm-js-sub-panel');
    if (panneau) panneau.hidden = !abo;
    if (champ) champ.value = abo && sel ? sel.value : '';
    var prix = bloc.querySelector('.pm-js-sub-now');
    if (prix && sel && sel.selectedOptions[0] && sel.selectedOptions[0].dataset.price) prix.textContent = sel.selectedOptions[0].dataset.price;
  }
  document.addEventListener('change', function (e) {
    var bloc = e.target.closest && e.target.closest('.pm-js-subopt');
    if (bloc) majAbonnement(bloc);
  });

  // ---- page des packs : onglets par univers ----------------------------------------
  document.addEventListener('click', function (e) {
    var onglet = e.target.closest('.pm-js-packs-tabs .pm-tab-btn');
    if (!onglet) return;
    var barre = onglet.closest('.pm-js-packs-tabs');
    barre.querySelectorAll('.pm-tab-btn').forEach(function (b) {
      var actif = b === onglet;
      b.classList.toggle('is-active', actif);
      b.setAttribute('aria-pressed', actif ? 'true' : 'false');
    });
    var voulu = onglet.dataset.u;
    document.querySelectorAll('.pm-packwrap').forEach(function (c) { c.hidden = !(voulu === 'tout' || c.dataset.u === voulu); });
    placerOnglets();
  });

  // ---- page univers : onglets par type, « Voir plus » sans quitter la page -----------
  var typeActif = 'tout';
  function appliquerType() {
    var n = 0;
    document.querySelectorAll('.pm-typed').forEach(function (c) {
      var ok = typeActif === 'tout' || c.dataset.type === typeActif;
      c.hidden = !ok;
      if (ok) n++;
    });
    var compteur = document.querySelector('.pm-listbar__count strong');
    if (compteur) compteur.textContent = n + ' produit' + (n > 1 ? 's' : '');
    var vide = document.querySelector('.pm-js-type-empty');
    if (vide) vide.hidden = n > 0;
  }
  function pageSuivante() {
    var nav = document.querySelector('.pm-loadmore');
    var lien = nav && nav.querySelector('a[href*="page="]');
    var grille = document.querySelector('.pm-grid--4');
    if (!lien || !grille) return Promise.resolve(false);
    return fetch(lien.href, { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        doc.querySelectorAll('.pm-grid--4 > .pm-typed').forEach(function (c) { grille.appendChild(document.importNode(c, true)); });
        var neuf = doc.querySelector('.pm-loadmore');
        if (neuf) nav.replaceWith(document.importNode(neuf, true)); else nav.remove();
        return true;
      })
      .catch(function () { return false; });
  }
  function toutCharger() {
    return pageSuivante().then(function (encore) { return encore ? toutCharger() : null; });
  }
  document.addEventListener('click', function (e) {
    var plus = e.target.closest('.pm-loadmore a[href*="page="]');
    if (plus && document.querySelector('.pm-grid--4 .pm-typed')) {
      e.preventDefault();
      plus.setAttribute('aria-busy', 'true');
      pageSuivante().then(appliquerType);
      return;
    }
    var onglet = e.target.closest('.pm-js-type-tabs .pm-tab-btn');
    if (!onglet) return;
    var barre = onglet.closest('.pm-js-type-tabs');
    barre.querySelectorAll('.pm-tab-btn').forEach(function (b) {
      var actif = b === onglet;
      b.classList.toggle('is-active', actif);
      b.setAttribute('aria-pressed', actif ? 'true' : 'false');
    });
    typeActif = onglet.dataset.type;
    placerOnglets();
    appliquerType();
    // un onglet doit montrer tous les produits du type : on charge les pages restantes
    if (typeActif !== 'tout' && document.querySelector('.pm-loadmore a[href*="page="]')) {
      barre.setAttribute('aria-busy', 'true');
      toutCharger().then(function () { barre.removeAttribute('aria-busy'); appliquerType(); });
    }
  });
  // ---- tuiles « rayons » : une adresse « …/collections/wash#type-lessives » ouvre l'onglet du type puis descend sur la liste des produits --------
  function ouvrirType(type) {
    var onglet = document.querySelector('.pm-js-type-tabs .pm-tab-btn[data-type="' + String(type).replace(/"/g, '') + '"]');
    var liste = document.getElementById('produits');
    if (onglet && !onglet.classList.contains('is-active')) onglet.click();
    if (liste && liste.scrollIntoView) liste.scrollIntoView({ behavior: window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
  }
  function typeDeLAdresse() {
    var m = /^#type-(.+)$/.exec(location.hash);
    return m ? decodeURIComponent(m[1]) : null;
  }
  window.addEventListener('hashchange', function () { var t = typeDeLAdresse(); if (t) ouvrirType(t); });
  document.addEventListener('click', function (e) {
    var tuile = e.target.closest('a.pm-cat[href*="#type-"]');
    if (!tuile) return;
    var url = new URL(tuile.href, location.href);
    if (url.pathname !== location.pathname) return; // autre page : navigation normale, l'onglet s'ouvrira au chargement
    e.preventDefault();
    if (window.history && history.replaceState) history.replaceState(null, '', url.pathname + url.search + url.hash);
    ouvrirType(url.hash.replace(/^#type-/, ''));
  });
  function initOffres() {
    document.querySelectorAll('[data-offers]').forEach(function (grille) {
      var max = parseInt(grille.dataset.max, 10) || 4;
      // « Tout » : un produit de chaque univers à tour de rôle (Wash, Sakan, Misk…), au lieu de l'ordre de la collection
      var cartes = Array.prototype.slice.call(grille.querySelectorAll('.pm-offer[data-rang]'));
      if (cartes.length) {
        var ordreU = ['wash', 'sakan', 'misk', 'autre'];
        cartes.sort(function (a, b) {
          return (+a.dataset.rang - +b.dataset.rang) || (ordreU.indexOf(a.dataset.u) - ordreU.indexOf(b.dataset.u));
        }).forEach(function (c) { grille.appendChild(c); });
      }
      if (grille.hasAttribute('data-carrousel')) return; // carrousel : tous les produits restent visibles
      grille.querySelectorAll('.pm-offer').forEach(function (c, i) { c.hidden = i >= max; });
    });
  }

  // ---- suggestions : rangée chargée après la page ----------------------------------
  function initSuggestions() {
    document.querySelectorAll('.pm-js-reco[data-url]').forEach(function (bloc) {
      if (bloc.querySelector('.pm-grid')) return;
      fetch(bloc.dataset.url)
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var neuf = doc.querySelector('.pm-js-reco');
          if (neuf && neuf.querySelector('.pm-grid')) bloc.innerHTML = neuf.innerHTML;
        })
        .catch(function () { /* pas de suggestions, la page reste complète */ });
    });
  }
  // ---- offres flash : compte à rebours réel (date de fin en secondes Unix), l'offre se ferme à l'heure dite ----
  function initChrono() {
    var els = document.querySelectorAll('.pm-js-chrono[data-fin]');
    if (!els.length) return;
    function deux(n) { return (n < 10 ? '0' : '') + n; }
    function maj() {
      var maintenant = Math.floor(Date.now() / 1000), fini = true;
      els.forEach(function (el) {
        var reste = parseInt(el.dataset.fin, 10) - maintenant;
        if (reste <= 0) {
          el.textContent = 'Terminée';
          var sec = el.closest('.pm-flash, .pm-pdflash'); if (sec) sec.classList.add('is-fini');
          return;
        }
        fini = false;
        var j = Math.floor(reste / 86400), h = Math.floor((reste % 86400) / 3600), m = Math.floor((reste % 3600) / 60), s = reste % 60;
        el.textContent = (j ? j + ' j ' : '') + (j || h ? deux(h) + ' h ' : '') + deux(m) + ' min ' + deux(s) + ' s';
      });
      if (fini) { clearInterval(tic); setTimeout(function () { location.reload(); }, 1500); }
    }
    var tic = setInterval(maj, 1000); maj();
  }
  // ---- barre d'achat mobile : visible quand le bouton de la fiche est passé, cachée au pied de page ----
  function initBarreAchat() {
    var barre = document.querySelector('.pm-js-buybar');
    var cta = document.querySelector('.pm-pd__cta');
    var pied = document.querySelector('.pm-footer');
    if (!barre || !('IntersectionObserver' in window)) return;
    var ctaVu = true, piedVu = false;
    function maj() { barre.classList.toggle('is-off', ctaVu || piedVu); }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.target === cta) ctaVu = e.isIntersecting || e.boundingClientRect.top > 0;
        if (e.target === pied) piedVu = e.isIntersecting;
      });
      maj();
    });
    if (cta) io.observe(cta); else ctaVu = false;
    if (pied) io.observe(pied);
    maj();
  }
  // ---- suggestions de recherche pendant la frappe : photo, nom et prix des produits qui correspondent (clavier et lecteurs d'écran pris en charge) ----
  function initRecherche() {
    var devise = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR', fmt = null;
    try { fmt = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: devise }); } catch (e) { fmt = null; }
    document.querySelectorAll('form[action$="/search"] input[name="q"]').forEach(function (champ, rang) {
      var form = champ.closest('form');
      if (!form || form.dataset.suggest) return;
      form.dataset.suggest = '1';
      form.classList.add('pm-has-suggest');
      var boite = document.createElement('div');
      boite.className = 'pm-suggest'; boite.id = 'pm-suggest-' + rang; boite.setAttribute('role', 'listbox'); boite.setAttribute('aria-label', 'Suggestions de produits'); boite.hidden = true;
      form.appendChild(boite);
      champ.setAttribute('role', 'combobox'); champ.setAttribute('aria-autocomplete', 'list'); champ.setAttribute('aria-expanded', 'false'); champ.setAttribute('aria-controls', boite.id); champ.setAttribute('autocomplete', 'off');
      var minuteur = null, controleur = null, actif = -1;
      function options() { return boite.querySelectorAll('[role="option"]'); }
      function fermer() { boite.hidden = true; champ.setAttribute('aria-expanded', 'false'); champ.removeAttribute('aria-activedescendant'); actif = -1; }
      function marquer(i) {
        var o = options(); if (!o.length) return;
        actif = (i + o.length) % o.length;
        o.forEach(function (el, k) { el.setAttribute('aria-selected', k === actif ? 'true' : 'false'); el.classList.toggle('is-actif', k === actif); });
        champ.setAttribute('aria-activedescendant', o[actif].id);
        if (o[actif].scrollIntoView) o[actif].scrollIntoView({ block: 'nearest' });
      }
      // la suggestion de Shopify tolère les fautes jusqu'à proposer des produits sans rapport (« zzzzzz » → matelas) : on garde les résultats
      // seulement si au moins un contient le début de ce qui est tapé (3 premières lettres, sans accents) dans son nom, sa marque ou son type
      function sansAccents(s) { return String(s || '').normalize ? String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase() : String(s || '').toLowerCase(); }
      function pertinent(terme, produits) {
        var debut = sansAccents(terme).slice(0, 3);
        return produits.some(function (p) { return sansAccents([p.title, p.vendor, p.type].join(' ')).indexOf(debut) > -1; });
      }
      function afficher(terme, produits) {
        if (!pertinent(terme, produits)) produits = [];
        boite.textContent = '';
        produits.forEach(function (p, k) {
          var a = document.createElement('a');
          a.className = 'pm-suggest__item' + (p.available === false ? ' is-epuise' : ''); a.href = p.url; a.id = boite.id + '-' + k; a.setAttribute('role', 'option'); a.setAttribute('aria-selected', 'false');
          var vignette = document.createElement('span'); vignette.className = 'pm-suggest__img';
          var src = (p.featured_image && p.featured_image.url) || p.image;
          if (src) { var im = document.createElement('img'); im.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=120'; im.alt = ''; im.width = 48; im.height = 48; im.loading = 'lazy'; vignette.appendChild(im); }
          var texte = document.createElement('span'); texte.className = 'pm-suggest__txt';
          var nom = document.createElement('span'); nom.className = 'pm-suggest__nom'; nom.textContent = p.title;
          var prix = document.createElement('span'); prix.className = 'pm-suggest__prix';
          var n = Number(p.price);
          prix.textContent = p.available === false ? 'Rupture de stock' : (isFinite(n) ? (fmt ? fmt.format(n) : n.toFixed(2) + ' €') : '');
          texte.appendChild(nom); texte.appendChild(prix);
          a.appendChild(vignette); a.appendChild(texte); boite.appendChild(a);
        });
        var tous = document.createElement('a');
        tous.className = 'pm-suggest__tous'; tous.href = '/search?q=' + encodeURIComponent(terme); tous.id = boite.id + '-tous'; tous.setAttribute('role', 'option'); tous.setAttribute('aria-selected', 'false');
        tous.textContent = produits.length ? 'Voir tous les résultats pour « ' + terme + ' »' : 'Aucun produit trouvé pour « ' + terme + ' » : voir la recherche';
        boite.appendChild(tous);
        boite.hidden = false; champ.setAttribute('aria-expanded', 'true'); actif = -1;
      }
      function chercher() {
        var terme = champ.value.trim();
        if (terme.length < 2) { fermer(); return; }
        if (controleur) controleur.abort();
        controleur = window.AbortController ? new AbortController() : null;
        fetch('/search/suggest.json?q=' + encodeURIComponent(terme) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,vendor,tag,variants.title,variants.sku', controleur ? { signal: controleur.signal, headers: { Accept: 'application/json' } } : { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (j) { if (!j || champ.value.trim() !== terme) return; afficher(terme, (j.resources && j.resources.results && j.resources.results.products) || []); })
          .catch(function () { /* recherche normale au clic sur Entrée : on ne montre rien */ });
      }
      champ.addEventListener('input', function () { clearTimeout(minuteur); minuteur = setTimeout(chercher, 200); });
      champ.addEventListener('focus', function () { if (champ.value.trim().length >= 2 && boite.childElementCount) boite.hidden = false, champ.setAttribute('aria-expanded', 'true'); });
      champ.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { fermer(); return; }
        if (boite.hidden) return;
        if (e.key === 'ArrowDown') { e.preventDefault(); marquer(actif + 1); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); marquer(actif - 1); }
        else if (e.key === 'Enter' && actif >= 0) { e.preventDefault(); window.location.href = options()[actif].href; }
      });
      document.addEventListener('click', function (e) { if (!form.contains(e.target)) fermer(); });
      form.addEventListener('focusout', function () { setTimeout(function () { if (!form.contains(document.activeElement)) fermer(); }, 120); });
    });
  }
  function init() { initOffres(); initCarrousels(); placerOnglets(); initAvis(); initSuggestions(); trierFrequences(); initBarreAchat(); initChrono(); initRecherche(); var t = typeDeLAdresse(); if (t) ouvrirType(t); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', peindre); else peindre();

  // ---- éclat : petites animations (rien si « réduire les animations ») -----------
  var calme = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // en-tête : ombre dès qu'on défile
  var defile = false;
  function majDefile() {
    defile = false;
    document.documentElement.classList.toggle('is-scrolled', window.scrollY > 8);
  }
  window.addEventListener('scroll', function () { if (!defile) { defile = true; requestAnimationFrame(majDefile); } }, { passive: true });
  majDefile();

  if (!calme) {
    // ondulation au clic sur les boutons
    document.addEventListener('pointerdown', function (e) {
      var b = e.target.closest('.pm-btn--primary, .pm-btn--whatsapp');
      if (!b) return;
      var r = b.getBoundingClientRect();
      var o = document.createElement('span');
      o.className = 'pm-ripple';
      o.style.left = (e.clientX - r.left) + 'px';
      o.style.top = (e.clientY - r.top) + 'px';
      b.appendChild(o);
      setTimeout(function () { o.remove(); }, 700);
    });

    // compteur du panier qui saute quand il change
    document.querySelectorAll('.pm-js-cart-count').forEach(function (el) {
      new MutationObserver(function () {
        el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump');
      }).observe(el, { childList: true, characterData: true, subtree: true });
    });

    // images des cartes : apparition douce une fois chargées (celles déjà là ne bougent pas)
    function fondu(img) {
      if (img.dataset.fondu) return;
      img.dataset.fondu = '1';
      if (img.complete && img.naturalWidth) return;
      img.classList.add('pm-js-img-wait');
      var fin = function () { img.classList.remove('pm-js-img-wait'); img.classList.add('pm-js-img-in'); };
      img.addEventListener('load', fin, { once: true });
      img.addEventListener('error', fin, { once: true });
    }
    var selImg = '.pm-product__media img, .pm-pack-card img, .pm-pd__img';
    document.querySelectorAll(selImg).forEach(fondu);
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          if (n.matches && n.matches(selImg)) fondu(n);
          if (n.querySelectorAll) n.querySelectorAll(selImg).forEach(fondu);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
